import React, { useEffect, useState } from "react";

interface CountdownProps {
  target: string | null | undefined; // ISO date the next puzzle starts
}

const pad = (n: number) => n.toString().padStart(2, "0");

// "Next Matchset in 2d 04:12:09" (live), or a friendly fallback
const Countdown: React.FC<CountdownProps> = ({ target }) => {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!target) return;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [target]);

  if (!target) return <p className="countdown">A new puzzle is coming soon. Check back next week!</p>;

  const ms = new Date(target).getTime() - now;
  if (ms <= 0) {
    return (
      <p className="countdown">
        A new Matchset is ready!{" "}
        <button type="button" className="link-button" onClick={() => window.location.reload()}>
          Play it now
        </button>
      </p>
    );
  }

  const s = Math.floor(ms / 1000);
  const days = Math.floor(s / 86400);
  const hms = `${pad(Math.floor((s % 86400) / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
  return (
    <div className="countdown">
      <div className="countdown-label">Next Matchset in</div>
      <div className="countdown-time" aria-live="off">
        {days > 0 && <span>{days}d </span>}
        {hms}
      </div>
    </div>
  );
};

export default Countdown;
